<template>
	<div class="well well-sm">
		<div class="row">
			<div class="col-sm-2">
				<span>Proposta</span>
				<button class="btn btn-info btn-block">
					<i class="fa fa-calculator"></i>
					{{ data.cod | pad }}
				</button>
			</div>
			<div class="col-sm-9">
				<span>Empresa</span>
				<drop-draw :asset="inOrderEmp" radio v-model="data.cnpj" />

				<!-- <pre>{{inOrderEmp}}</pre> -->
				<!--
          	<div class="input-group">
          		<span class="input-group-addon" @click='openModalEmpresa'>
          			<i class="fa fa-address-card-o"></i>
          		</span>
          		<select :disabled='data.status == "CS"' class="form-control"
          		  @change='$emit("toggleRegiao", $event)' v-model="data.cnpj">
            			<option value="">Escolher empresa</option>
            			<option v-for="(emp, index) in inOrderEmp" :key="index" :value="emp.cnpj">
            				{{emp.razao_social}} - {{emp.cnpj}}
            			</option>
          		</select>
          	</div>  -->
			</div>
			<!-- <div class="col-sm-3">
          	<span>CNPJ</span>
          	<input class="form-control" :value='data.cnpj' disabled />
        </div> -->
			<div class="col-sm-1">
				<br />
				<button
					class="btn btn-success btn-block"
					@click="openMdCliente()"
				>
					<i class="fa fa-plus"></i>
				</button>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash';
	import dropDraw from 'app/drop-draw';

	export default {
		name: 'HeaderProps',
		inject: ['openMdCliente'],
		components: { dropDraw },
		props: ['dIn', 'assets'],
		filters: {
			pad(val) {
				return _.padStart(val, 5, '0');
			},
		},
		computed: {
			inOrderEmp() {
				const clientes = this.assets.clientes.reduce((acc, item) => {
					acc.push({
						cod: item.cnpj,
						title: `<b>${item.regiao} - ${item.cnpj}</b>- ${item.razao_social}`,
					});
					return acc;
				}, []);

				return _.orderBy(clientes, ['title'], ['asc']);
			},
			data() {
				return this.dIn;
			},
		},
		methods: {
			openModalEmpresa() {
				// Abiri modal de clientes
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/proposals/components/components/header.vue